/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loud_Cool_Goat_FlowInputs */

const en_loud_cool_goat_flow = /** @type {(inputs: Loud_Cool_Goat_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last activity`)
};

const de_loud_cool_goat_flow = /** @type {(inputs: Loud_Cool_Goat_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Aktivität`)
};

/**
* | output |
* | --- |
* | "Last activity" |
*
* @param {Loud_Cool_Goat_FlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const loud_cool_goat_flow = /** @type {((inputs?: Loud_Cool_Goat_FlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loud_Cool_Goat_FlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loud_cool_goat_flow(inputs)
	return de_loud_cool_goat_flow(inputs)
});